'use strict';

/**
 *  Load modules
 */

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

require('./modules/slick.min.js');
require('./modules/amsifyselect.js');
require('./modules/fancybox.min.js');
require('./modules/jquery.mask.js');

import functions from './modules/functions.js';
import scripts from './modules/scripts.js';
import glossary from './modules/glossary.js';

$(document).ready(() => {

    functions();
    scripts();
    glossary();

});
